import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "client-dashboard-content" }
const _hoisted_2 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"space-between","margin-left":"30px"}
}
const _hoisted_3 = { class: "welcome-title-consultant-client-dashboard" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "back-to-all-clients-client-dashboard" }
const _hoisted_7 = { class: "client-dashboard-block" }
const _hoisted_8 = { style: {"position":"relative","width":"100%","height":"100%"} }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { style: {"position":"absolute","top":"140px","bottom":"100px","left":"40px","right":"40px","min-width":"calc(100% - 110px)","border-radius":"10px","min-height":"90px","background-color":"#ffffff"} }
const _hoisted_11 = { style: {"position":"relative","width":"100%","height":"100%"} }
const _hoisted_12 = { style: {"position":"absolute","top":"0px","left":"0px","right":"0px","height":"50px","background-color":"#F3F4F8","border-radius":"10px","min-width":"1000px"} }
const _hoisted_13 = { style: {"position":"relative","width":"100%","height":"100%","min-width":"1000px"} }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { style: {"position":"absolute","top":"65px","left":"0px","right":"0px","bottom":"10px"} }
const _hoisted_18 = { style: {"position":"relative","width":"100%","min-width":"1000px","height":"70px","background-color":"#FFFFFF","border-bottom-left-radius":"10px","border-bottom-right-radius":"10px"} }
const _hoisted_19 = { style: {"float":"left","width":"40%","min-width":"300px","font-family":"'Public Sans'","font-size":"16px","line-height":"50px","text-align":"left","padding-left":"20px"} }
const _hoisted_20 = { style: {"float":"left","width":"30%","min-width":"300px","font-family":"'Public Sans'","font-size":"16px","line-height":"70px","text-align":"left"} }
const _hoisted_21 = { style: {"float":"left","width":"200px","min-width":"300px","font-family":"'Public Sans'","font-size":"16px","line-height":"70px","text-align":"left","padding-top":"20px"} }
const _hoisted_22 = { style: {"position":"relative","width":"100%","min-width":"1000px","height":"70px","background-color":"#FFFFFF","border-bottom-left-radius":"10px","border-bottom-right-radius":"10px"} }
const _hoisted_23 = {
  key: 0,
  style: {"float":"left","width":"40%","min-width":"300px","font-family":"'Public Sans'","font-size":"16px","line-height":"50px","text-align":"left","padding-left":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IciButton = _resolveComponent("IciButton")!
  const _component_IciStatus = _resolveComponent("IciStatus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.selectedClient.id != 0)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              innerHTML: _ctx.selectedClient.name
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.selectedClient.id == 0)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              innerHTML: _ctx.$t('companyForm.titleAddNewClient')
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_IciButton, {
          id: "backToAllClients",
          content: _ctx.constructLabel(_ctx.buttonBackToAllClients, _ctx.$t('companyForm.buttonBackToAllClients')),
          onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToAllClients())),
          btnStyle: "width: fit-content; height: auto; padding: 18px 24px!important; top: 32px; position: static;"
        }, null, 8, ["content"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          style: {"position":"absolute","top":"40px","left":"40px","right":"40px","height":"50px","border-radius":"10px","background-color":"#fbfaff","font-family":"'Public Sans'","font-weight":"bold","text-align":"left","padding-left":"40px","line-height":"50px"},
          innerHTML: _ctx.$t('companyForm.titleDashboard')
        }, null, 8, _hoisted_9),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  style: {"float":"left","width":"40%","min-width":"300px","font-family":"'Public Sans'","font-weight":"bold","font-size":"16px","line-height":"50px","text-align":"left","padding-left":"30px"},
                  innerHTML: _ctx.$t('companyForm.tableHeaderActiveProject')
                }, null, 8, _hoisted_14),
                _createElementVNode("div", {
                  style: {"float":"left","width":"30%","min-width":"300px","font-family":"'Public Sans'","font-weight":"bold","font-size":"16px","line-height":"50px","text-align":"left"},
                  innerHTML: _ctx.$t('companyForm.tableHeaderQuestionnaireDeadline')
                }, null, 8, _hoisted_15),
                _createElementVNode("div", {
                  style: {"float":"left","width":"30%","min-width":"300px","font-family":"'Public Sans'","font-weight":"bold","font-size":"16px","line-height":"50px","text-align":"left"},
                  innerHTML: _ctx.$t('companyForm.tableHeaderProjectStatus')
                }, null, 8, _hoisted_16)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              (_ctx.questionnaireList.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.questionnaireList, (questionnaire) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        (questionnaire.status == _ctx.QuestionnaireState.CLOSED)
                          ? (_openBlock(), _createBlock(_component_IciButton, {
                              key: 0,
                              id: 'buttonClick@',
                              content: questionnaire.name,
                              onButtonClick: ($event: any) => (_ctx.projectDashboard(questionnaire.id)),
                              btnStyle: "width: fit-content; height: auto; padding: 18px 24px!important;"
                            }, null, 8, ["content", "onButtonClick"]))
                          : (_openBlock(), _createBlock(_component_IciButton, {
                              key: 1,
                              id: 'buttonClick@',
                              content: questionnaire.name,
                              onButtonClick: ($event: any) => (_ctx.projectDetails(questionnaire.id)),
                              btnStyle: "width: fit-content; height: auto; padding: 18px 24px!important;"
                            }, null, 8, ["content", "onButtonClick"]))
                      ]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(questionnaire.deadlineFormatted), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_IciStatus, {
                          state: questionnaire.status
                        }, null, 8, ["state"])
                      ])
                    ]))
                  }), 256))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                (_ctx.newProject == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_IciButton, {
                        id: 'buttonClick@',
                        content: _ctx.constructLabel(_ctx.buttonAddProject, _ctx.$t('companyForm.buttonNewProject')),
                        onButtonClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addProject())),
                        btnStyle: "width: fit-content; height: auto; padding: 18px 24px!important;"
                      }, null, 8, ["content"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}